<div *ngIf="sensorReadings.length != undefined" (click)="openBigChart(bigChart)" style="cursor: pointer; width: 100%; height: 35px; background-color: clear; border: 0.5px dotted lightgray;">
    <canvas baseChart
        [type]="chartType"
        [data]="{ datasets: chartjsData, labels: chartjsLabels }"
        [options]="chartjsOptions">
    </canvas>
</div>


<ng-template #bigChart>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="bigChart">
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Event & Actions '{{ currentEventName }}'</h5>
            <button
                (click)="modalRef.hide()"
                class="ms-auto fas fa-times"pe="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
            </button>
        </div>

        <div class="modal-body" style="padding-left: 10px; background-color: white;">
            <div>
                <button (click)="showDataPointsOnChart(bigChartRef)" class="btn btn-primary" type="button" style="margin-bottom: 5px; margin-left: 12px; width: 190px;">Show Data Points</button>
                <button (click)="charting.saveChartAsImage('chartContainer2', 'chart')" class="btn btn-primary btn-sm" type="button" style="margin-left: 45px;" ><i class="fa-solid fa-download"></i> JPG</button>
            </div>
            <div id="chartContainer2" style="background-color: white;">
              <ngx-charts-line-chart #bigChartRef
                  [view]="ngxChartView"
                  [scheme]="bigChartOptions.colorScheme"
                  [results]="ngxChartData"
                  [gradient]="bigChartOptions.gradient"
                  [xAxis]="bigChartOptions.showXAxis"
                  [yAxis]="bigChartOptions.showYAxis"
                  [legend]="bigChartOptions.showLegend"
                  [showXAxisLabel]="bigChartOptions.showXAxisLabel"
                  [showYAxisLabel]="bigChartOptions.showYAxisLabel"
                  [xAxisLabel]="bigChartOptions.xAxisLabel"
                  [yAxisLabel]="bigChartOptions.yAxisLabel"
                  [autoScale]="bigChartOptions.autoScale"
                  [xAxisTickFormatting]="bigChartOptions.axisFormat"
                  [legendTitle]="bigChartOptions.legendTitle"
                  [timeline]="bigChartOptions.timeline"
                  [yScaleMin]="bigChartOptions.scaleYMin"
                  [yScaleMax]="bigChartOptions.scaleYMax">
              </ngx-charts-line-chart>
            </div>
        </div>
    </div>
</ng-template>

